import React from 'react';
import {useTranslations} from "use-intl";

import {BreadCrumbType} from '@/typings/common';
import {useSettingItem} from '@/hooks';
import {useTypedSelector} from '@/store/store';
import {selectBlogCategoryList} from '@/store/reducers/tager/blog';
import BlogSharedHeader from '@/components/BlogSharedHeader';

const Top = () => {
  const t = useTranslations();

  const Title = useSettingItem('TEXT_BLOG_TITLE');
  const categories = useTypedSelector(selectBlogCategoryList);
  const breadCrumbList: BreadCrumbType[] = [];
  breadCrumbList.push({
    url: '/blog',
    label: t('blog.title'),
  });

  return (
    <BlogSharedHeader
      categories={categories}
      pageTitle={Title ?? t('blog.title')}
      breadCrumbList={breadCrumbList}
      className="glossary-navigation"
    />
  );
};

export default Top;
